<template>
	<div v-show="errorArr.length > 0" class="tips-border clearfix">
		<div class="float-left padding-top-5">
			<img src="../images/icon-i.png" >
		</div>
		<div class="float-left font-12 margin-left-5 text-danger tips-sx">
			<div>{{ errorArr.join('、') }}</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['errorArr'],
};
</script>
